import React from 'react';
import { FaSun, FaMoon} from "react-icons/fa";
import { ThemeContext } from "../Component/ThemeContext";

const Toggle = () => {
    const { theme, setTheme } = React.useContext(ThemeContext);

    return (
        <div className="transition duration-500 ease-in-out rounded-full pl-2 mt-[4px]">
            {theme === 'dark' ? (
                <FaSun
                    onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
                    className="text-[#F9D71C] dark:text-[#F9D71C] text-2xl cursor-pointer"
                />
            ) : (
                    <FaMoon
                        onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
                        className="text-[#E07C24] dark:text-[#E07C24] text-2xl cursor-pointer"
                    />
                )}
        </div>
    );
};

export default Toggle;